// --------------------------------------------------------
// OCCUPATIONAL HEALTH LIST - OccupationalHealthList
// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
import React, { useCallback, useEffect, useState } from 'react'
import LabelInput from '../../components/labelInput/LabelInput';
import ContainerWithSidebar from '../../components/UI/containerWithSidebar/ContainerWithSidebar';
import { GeneralContainer, Text } from '../../components/UI/generalLayout/Layout.styled';
import ScreenHeader from '../../components/UI/screenHeader/ScreenHeader';
import SearchIcon from '@mui/icons-material/Search';
import Colors from '../../constants/Colors';
import CareLineListItem from '../../components/careLineListItem/CareLineListItem';
import ItemList from '../../components/itemList/ItemList';
import { CompanyListItemContainer } from '../company/CompanyList.styled';
import { useNavigate } from 'react-router-dom';
import { Paths } from '../../enums/Paths';
import OccupationalHealth from '../../models/core/occupationalHealth/OccupationalHealth';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../..';
import * as occupHealthActions from '../../store/actions/occupationalHealth';
import Company from '../../models/core/company/Company';
import { executeWithDelay } from '../../helpers/HelperFunctions';

// --------------------------------------------------------
// OCCUPATIONAL HEALTH LIST INTERFACE
// --------------------------------------------------------

/**
 * A component that renders a Screen.
 *
 * @param props Properties
 * @param props.route The route
 * @param props.navigation The navigator
 * @returns The component JSX.
 */
function OccupationalHealthList(): JSX.Element {
  // --------------------------------------------------------
  // OCCUPATIONAL HEALTH LIST PRIVATE DECLARATIONS
  // --------------------------------------------------------
  const [occupationalHealthSearchQuery, setOccupationalHealthSearchQuery] = useState('')
  const [occupationalHealthHeaderFields] = useState([{name: 'Nome da saúde ocupacional', width: '80%', align: null}, {name: 'Ativar/Desativar', width: '20%', align: 'right'}])

  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const occupationalHealthList: OccupationalHealth[] = useSelector((state: any)=>state.occupationalHealth.occupHealthList)
  const currentCompany: Company = useSelector((state: any)=>state.login.currentCompany)
  
  const fetchOccupationalHealthList = useCallback(async ()=>{
    await dispatch(occupHealthActions.fetchOccupationalHealth(currentCompany?.id))
  }, [dispatch])

  const filterDataByName = useCallback(async ()=>{
    if(occupationalHealthSearchQuery.length >= 3 || occupationalHealthSearchQuery === ''){
      executeWithDelay(500, async ()=>{
          await dispatch(occupHealthActions.filterOccupationalHealthByName(currentCompany?.id, occupationalHealthSearchQuery))
      })
    }
  }, [occupationalHealthSearchQuery])
  
  useEffect(()=>{
    fetchOccupationalHealthList()
  }, [currentCompany])

  useEffect(()=>{
    filterDataByName();
  }, [occupationalHealthSearchQuery])

  const activateOrInactivateOccupationalHealth = async (id: string, occupHealthId: string, isActive: boolean)=>{
    await dispatch(occupHealthActions.activateOrDeactivateOccupationalHealth(id, occupHealthId, isActive))
    fetchOccupationalHealthList();
  }
  
  const navigateToOccupHealthRegister = ()=>{
    return navigate(Paths.OccupationalHealthRegister)
  }

  const navigateToOccupHealthRegisterEdit = (occupHealth: any)=>{
    return navigate(Paths.OccupationalHealthRegister, { state: { occupHealth: occupHealth }})
  }

  const navigateToOccupHealthRegisterView = (occupHealth: any)=>{
    return navigate(Paths.OccupationalHealthRegister, { state: { occupHealth: occupHealth, isView: true }})
  }

  return <ContainerWithSidebar>
    <GeneralContainer>
        <ScreenHeader 
            screenTitle={'Saúde Ocupacional'} 
            rightButtonText={'Cadastrar nova saúde ocupacional'} 
            onRightButtonClick={navigateToOccupHealthRegister}        
        />
        <LabelInput
            value={occupationalHealthSearchQuery}
            placeholder="Busca de saúde ocupacional"
            onChangeText={(event: any) => { setOccupationalHealthSearchQuery(event.target.value) }}
            rightIcon={<SearchIcon />}
        />
        {occupationalHealthSearchQuery.length > 2 && (<div style={{ paddingLeft: 12, paddingRight: 12 }}><Text color={Colors.lightBlue}>Resultados para: {occupationalHealthSearchQuery} </Text></div>)}
        <ItemList listHeader={occupationalHealthHeaderFields} list={occupationalHealthList}>
            <CompanyListItemContainer>
                {occupationalHealthList.map(occupHealth=>{
                    return <CareLineListItem 
                                isOccupHealth={true}
                                companyId={currentCompany?.id}
                                id={occupHealth.id}
                                onActivateInactivate={activateOrInactivateOccupationalHealth}  
                                onView={()=>{navigateToOccupHealthRegisterView(occupHealth)}}
                                onEdit={()=>{navigateToOccupHealthRegisterEdit(occupHealth)}}
                                name={occupHealth.nome} 
                                isActiveRegister={!occupHealth.inativo} 
                            />
                })}
            </CompanyListItemContainer>
        </ItemList>
    </GeneralContainer>
  </ContainerWithSidebar>;
}

export default OccupationalHealthList;
